import { render, staticRenderFns } from "./EstimateDetail.vue?vue&type=template&id=4fa1dce2&scoped=true"
import script from "./EstimateDetail.vue?vue&type=script&lang=js"
export * from "./EstimateDetail.vue?vue&type=script&lang=js"
import style0 from "./EstimateDetail.vue?vue&type=style&index=0&id=4fa1dce2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1dce2",
  null
  
)

export default component.exports